module.exports = __webpack_public_path__ + "img/tab1.9b7f5b23.png";